import type {
  ModelBackendCard,
  ModelCardRates,
  ModelCardTemplate,
  ModelCardTemplateId,
} from '@shared-core/features/backend/models'
import { Big } from '@shared-core/utils/balances/big'

export function getCardTemplateId(card: ModelBackendCard): ModelCardTemplateId {
  return card.templateId ?? card.type
}

export function isBlockedCardStatus(status?: string): boolean {
  return status === 'blocked' || status === 'blocking'
}

export function isFrozenCardStatus(status?: string): boolean {
  return status === 'frozen' || status === 'unfreezing'
}

// Курсы самой карты приоритетнее шаблона: шаблон могут отключить или изменить. Шаблон — запасной вариант для старых ответов.
export function getCardRates(card: ModelBackendCard, templates: ModelCardTemplate[]): ModelCardRates | undefined {
  return card.rates ?? findCardTemplateRates(templates, getCardTemplateId(card))
}

export function findCardTemplateRates(
  templates: ModelCardTemplate[],
  templateId?: ModelCardTemplateId,
): ModelCardTemplate['rates'] | undefined {
  return templates.find((template) => template.id === templateId)?.rates
}

// Ставка приходит строкой с сервера: некорректное значение считаем недоступной операцией.
export function hasPositiveRate(rate: string | undefined): boolean {
  if (!rate) return false

  try {
    return Big(rate).gt(0)
  } catch {
    return false
  }
}
